import { User } from 'firebase/auth';
import ProfileClass from '../profile/profileClass';
import UserInterface from './userInterface';

export default class UserClass extends ProfileClass implements UserInterface {
    admin: {
        role: 'admin' | 'user';
        verified: boolean;
    };
    auth: User;

    constructor(data: Record<string, any>) {
        super(data);
        this.admin = data.admin;
        this.auth = data.auth;
    }

    isAdmin(): boolean {
        return this.admin?.role === 'admin';
    }

    isVerified(): boolean {
        return this.admin?.verified || false;
    }

    toJSON(): Record<string, any> {
        var json = super.toJSON();
        return {
            id: this.id,
            data: {
                ...json.data,
                id: this.id,
                admin: this.admin
            }
        };
    }
}
